import styled from 'styled-components'
import { IconButton } from '@material-ui/core'
import { PlaylistPlay } from '@material-ui/icons'
import { colors } from '../../styles'
import { Caption } from '../StyledText'

export const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-bottom: 7px;
  padding-left: 24px;
  position: relative;
  span {
    font-size: 12px;
    font-family: knowledge2017bold;
    line-height: 14px;
    color: #393a3b;
  }
`

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: 0;
  top: -13px;
` as React.ComponentType<any>

export const StyledExpand = styled(PlaylistPlay)`
  font-size: 17px;
  font-weight: bold;
` as React.ComponentType<any>

export const StyledWarning = styled(Caption)`
  color: ${colors.error};
  padding: 0 12px 8px 24px;
  line-height: 16px;
`
